import { getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging';
import { firebaseApp } from './firebase';

let messagingPromise;

const getMessagingInstance = async () => {
  if (!messagingPromise) {
    messagingPromise = (async () => {
      const supported = await isSupported();
      if (!supported) {
        // eslint-disable-next-line no-console
        console.warn('[Firebase] Messaging no es compatible con este navegador.');
        return null;
      }
      return getMessaging(firebaseApp);
    })();
  }

  return messagingPromise;
};

export const ensureMessagingToken = async () => {
  if (!('Notification' in window)) {
    // eslint-disable-next-line no-console
    console.warn('[Firebase] API de notificaciones no disponible.');
    return null;
  }

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    // eslint-disable-next-line no-console
    console.warn('[Firebase] Permiso de notificaciones denegado.');
    return null;
  }

  if (!('serviceWorker' in navigator)) {
    // eslint-disable-next-line no-console
    console.warn('[Firebase] Service workers no soportados.');
    return null;
  }

  const messaging = await getMessagingInstance();
  if (!messaging) {
    return null;
  }

  const registration =
    (await navigator.serviceWorker.getRegistration('/service-worker.js')) ??
    (await navigator.serviceWorker.register('/service-worker.js'));

  try {
    const vapidKey = "BFLlLJhWY72VZQSq-zRZSAQK18zX3MHNsbCsqNW-qHxFRk7TjJNRA-GSWafO-r3lEprazirnSUpIVe2SzN38ygI";
    const token = await getToken(messaging, {
      vapidKey: vapidKey && vapidKey.trim().length > 0 ? vapidKey : undefined,
      serviceWorkerRegistration: registration
    });

    if (!token) {
      // eslint-disable-next-line no-console
      console.warn('[Firebase] No se pudo obtener el token de mensajería.');
      return null;
    }

    return token;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('[Firebase] Error al obtener el token de mensajería:', error);
    return null;
  }
};

export const attachForegroundMessageListener = async (handler) => {
  const messaging = await getMessagingInstance();
  if (!messaging) {
    return () => {};
  }

  const unsubscribe = onMessage(messaging, handler);
  return unsubscribe;
};

